import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'secondary' | 'tertiary' | 'goGreen'>
}>

export const Subtitle2 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="subtitle2" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
